<mos-modal #modal>
	<!-- Condition exists to trigger animations -->
	@if (modal.shouldDisplayContent()) {
	<div class="container" [mosLeaveSync]="'container-out'">
		<mos-header i18n="@@event.ashes-and-roses-launch.title">Ashes and Roses est sorti&nbsp;!</mos-header>

		<a [href]="link" target="_blank" rel="noopener">
			<picture>
				<source type="image/avif" srcset="/assets/images/landing/team/ashes-and-roses.avif" />
				<source type="image/webp" srcset="/assets/images/landing/team/ashes-and-roses.webp" />
				<img
					ngSrc="/assets/images/landing/team/ashes-and-roses.jpg"
					alt="Ashes and Roses"
					i18n-alt="@@event.ashes-and-roses-launch.alt"
					width="1200"
					height="627"
				/>
			</picture>
		</a>

		<p i18n="@@event.ashes-and-roses-launch.text">
			Le nouveau Visual Novel de Nineland, dans l'univers de <strong>Memory of Souls</strong>, est
			disponible&nbsp;!
		</p>

		<a class="button" [href]="link" target="_blank" rel="noopener" (click)="leave()">
			<span i18n="@@event.ashes-and-roses-launch.play">Découvrir Ashes and Roses</span>
		</a>

		<div class="button-container">
			<a
				role="button"
				tabindex="0"
				(click)="leave()"
				(keydown.enter)="leave()"
				(keydown.space)="leave(); $event.preventDefault()"
			>
				<span i18n="@@common.no-thanks">Non, merci !</span>
			</a>
		</div>
	</div>
	}
</mos-modal>
